import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import NeonStage from "@/components/NeonStage";
import { scrollToId } from "./scrollTo";

const HEADLINE = ["ИДЕИ, КОИТО", "ОСВЕТЯВАТ", "ПЪТЯ"];

const MaskLine = ({ children, delay, accent }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${accent ? "text-[#EE443E]" : "text-white"}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Hero = () => {
  return (
    <section id="hero" className="relative min-h-[230vh]" data-testid="hero-section">
      <div className="pin">
        <NeonStage variant="bulb" />
        <div className="text-block relative z-[1] w-full">
          <div className="w-1/2" data-testid="hero-content">
            <h1
              className="font-display uppercase leading-[1.16] text-5xl lg:text-[60px]"
              data-testid="hero-headline"
            >
              {HEADLINE.map((line, i) => (
                <MaskLine key={line} delay={0.2 + i * 0.1} accent={line === "ОСВЕТЯВАТ"}>
                  {line}
                </MaskLine>
              ))}
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.55, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 max-w-[44ch] text-lg leading-snug text-white"
              data-testid="hero-positioning"
            >
              Цялостни маркетингови решения — фото, видео, дизайн, текстове, социални мрежи, уеб. Запалваме идеите и ги превръщаме в резултат.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mt-11 flex flex-wrap items-center gap-[30px]"
            >
              <a
                href="#prices"
                onClick={scrollToId("prices")}
                className="inline-flex items-center gap-2 rounded-full bg-[var(--red)] text-white px-[30px] py-[15px] text-[15px] font-semibold uppercase tracking-wide hover:opacity-90 transition-opacity"
                data-testid="hero-cta-packages"
              >
                Избери пакет →
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
